export function slidePrev(idx: number, next: () => void) {
	if (idx === 0) {
		window.history.back();
	} else {
		next();
	}
}
